import ReactDOM from "react-dom";
import React from "react";
import Overview from './components/Overview'
import {ViewType} from "./types";
const BONUS_POINTS_OVERVIEW = document.getElementById('bonus-points-overview-wrapper');

if (!!BONUS_POINTS_OVERVIEW) {
    const siteDomain = BONUS_POINTS_OVERVIEW.getAttribute('data-site-domain');
    const siteId = Number(BONUS_POINTS_OVERVIEW.getAttribute('data-site-id'));
    const lang = BONUS_POINTS_OVERVIEW.getAttribute('data-lang');
    const view = BONUS_POINTS_OVERVIEW.getAttribute('data-view') as ViewType;

    ReactDOM.render(
        <Overview siteDomain={siteDomain} siteId={siteId} lang={lang} view={view}/>,
        BONUS_POINTS_OVERVIEW
    );
}
